import 'translations';
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import { UnheadProvider, createHead } from '@unhead/react/client';
import { Router } from 'business/router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'technical/react-query/client';
import defaultTheme from 'config/theme';
import { App as AntApp } from 'antd';
import { UpdateNotification } from 'technical/pwa/UpdateNotification';

const head = createHead();

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <StyleProvider layer>
        <ConfigProvider theme={defaultTheme}>
          <AntApp>
            <UpdateNotification />
            <UnheadProvider head={head}>
              <Router />
            </UnheadProvider>
          </AntApp>
        </ConfigProvider>
      </StyleProvider>
    </QueryClientProvider>
  );
};
